"use client";

/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* MATERIAL TAILWIND COMPONENTS */
import { IoSparkles } from "react-icons/io5";

/* COMPONENTS */
import LandingPageForm from "./landing-page-form";

const Banner = () => {
  return (
    <motion.div
      variants={animation}
      className="banner h-auto xl:h-banner lg:h-banner"
    >
      <div className="py-10 xl:py-0 lg:py-0 w-full h-full bg-black bg-opacity-80">
        <div className="container h-full flex items-center">
          <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-24 lg:gap-24 items-center">
            <div className="col-span-1">
              <div className="w-fit bg-primary rounded-full border-2 border-white px-3 py-1.5 shadow-md">
                <div className="flex items-center gap-2">
                  <IoSparkles className="hidden xl:block lg:block w-4 h-4 text-white" />
                  <h5 className="text-sm font-source font-medium text-white">
                    PATHWAY TO SUCCESS IN REAL ESTATE INDUSTRY
                  </h5>
                </div>
              </div>
              <h1 className="mt-5 xl:mt-10 lg:mt-10 text-3xl xl:text-4xl lg:text-4xl font-source font-bold text-white leading-tight xl:leading-normal lg:leading-normal">
                Real Estate Certificate Program for Your Career
              </h1>
              <h2 className="mt-5 xl:mt-10 lg:mt-10 text-lg xl:text-xl lg:text-xl font-source font-normal text-white leading-relaxed text-opacity-90">
                At Dream Force Academy, we offer comprehensive training programs
                designed to provide you with the knowledge and skills you need
                to succeed in this competitive industry.
              </h2>
            </div>
            <div className="col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-5 xl:p-10 lg:p-10">
                <div className="p-0">
                  <h5 className="text-xl font-source font-bold text-black">
                    Get your free consultation
                  </h5>
                  <p className="mt-1 xl:mt-0 lg:mt-0 text-base font-source font-normal text-greyText">
                    Learn from the best trainer in the industry!
                  </p>
                </div>

                <LandingPageForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Banner;
